<template>
  <div class="Maddle" >
    <div class="setwidth">
        <img class="image" src="./Folw/Folw.png" alt="">
    </div>
    <div  class="Folwtitle ">
        <img class="image" src="./Folw/title.png" alt="">
    </div>
    <!-- <div class="FolwF setwidth" >
        <img src="./Folw/FolwF.png" alt="">
    </div>
    <div class="FolwS setwidth" >
        <img src="./Folw/FolwS.png" alt="">
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.Maddle{
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // flex-direction: column;
    background-color: #FFFFFF;
    width: 100%;
    .setwidth{
        width: 100%;
        height: 460px*$sun;
    }
    .Folwtitle{
        width: 1260px*$sun;
        margin: 50px*$sun auto;
    }
    .FolwF{
        display: flex;
        justify-content: center;
        padding-bottom: 67px*$sun;
    }
    .FolwS{
        display: flex;
        justify-content: center;
        padding-bottom: 87px*$sun;
    }
}

.image{
    width: 100%;
    height: 100%;
}
</style>
